import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';





Vue.config.productionTip = false

/*
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;
*/

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);


import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css';
var toastrConfigs = {
  position: 'top center',
  showDuration: 500,
  timeOut	:3500,
  closeButton:true,
  progressBar:true,
  icon:"none",

}
Vue.use(CxltToastr, toastrConfigs)


import utils from './modules/utils';

Vue.use({
  install() {
      Vue.utils = utils;
      Vue.prototype.$utils = utils;
      Vue.axios = axios;
      Vue.prototype.$axios = axios;
  }
});





new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
